import { graphql } from "react-relay";
import { EventSchedulerAttendeeInput } from "@components/event-scheduler-attendee-input";
import "@components/autopilot-form/AutopilotForm.gql";

export const eventSchedulerFragments = {
  viewer: graphql`
    fragment EventScheduler_viewer on Viewer
    @argumentDefinitions(calendarIds: { type: "[String]!", defaultValue: [] }) {
      user {
        emails
        orgs(first: 1000000) {
          edges {
            node {
              ...AutopilotForm_org
              id
              domains
              primaryOrgEmail
              primaryOrgCalendar
              personsByCalendarIdsErrorable(calendarIds: $calendarIds) {
                ...EventSchedulerAttendeeInput_personsByCalendarIdsErrorable
                __typename
                ... on PersonList {
                  list {
                    id
                    emails
                    primaryEmail
                    profile {
                      givenName
                      familyName
                      externalImageUrl
                    }
                    isYou
                    isOutsideOrg
                  }
                }
                ... on GraphEntityError {
                  message
                }
              }
              zoomAccount {
                __typename
                ... on GraphEntityError {
                  message
                  statusCode
                }
                ... on ZoomAccount {
                  accountId
                  connected
                  displayName
                  hasValidZoomAccount
                }
              }
              zoomUserLevelAccount {
                __typename
                ... on GraphEntityError {
                  message
                  statusCode
                }
                ... on ZoomAccount {
                  connected
                }
              }
            }
          }
        }
      }
    }
  `,
};

export const eventSchedulerQuery = graphql`
  query EventSchedulerQuery($calendarIds: [String]!) {
    viewer {
      ...EventScheduler_viewer @arguments(calendarIds: $calendarIds)
    }
  }
`;
